import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '26257470350562748';
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    const n: any = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    w.fbq = n;
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-74">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=26257470350562748&ev=PageView&noscript=1" alt="" data-id="element-75" />
    </noscript>;
}